import React, { useContext, useCallback, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import isTokenExpired from '../../../utils/isTokenExpired';
import { AuthContext } from '../../../contexts/AuthContext';
import { Formik } from 'formik';
import userValidations from '../../../utils/userValidations';
import { PageContainer } from '../../../layouts';
import LoginForm from './LoginForm';
import {GlobalContext} from "../../../Store";


const Login = ({ history }) => {
  const { state, actions } = useContext(AuthContext);
  const { store: storeGlobal, dispatch } = useContext(GlobalContext);

  useEffect(() => {
    if (!isTokenExpired(state.jwt)) history.push('/products');
  }, [state.jwt, storeGlobal.jwt, dispatch, history]);

  const onSubmit = useCallback(
   async (data, { setSubmitting },formik) => {
    
    try{
      await actions.login(data, () => setSubmitting(false));
      
    }
    catch(err){
      if(err)
      console.log("result login catch:", err)
    }
     
      //formik.setErrors("Is already taken");
    },
    [actions]
  );

  return (
    <PageContainer component="main" maxWidth="xs">
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={userValidations.login}
       onSubmit={onSubmit}
      >
        {(props) => <LoginForm {...props} />}
      </Formik>
    </PageContainer>
  );
};

export default withRouter(Login);
